export default __webpack_public_path__ + "static/media/22.80e19cad.jpg";